import { t } from "i18next";

const WEEKLY_VIEW = t("neetoMolecules.calendarView.weekly");
const MONTHLY_VIEW = t("neetoMolecules.calendarView.monthly");
const DAILY_VIEW = t("neetoMolecules.calendarView.daily");

export const VIEW_OPTIONS = {
  [DAILY_VIEW]: {
    label: DAILY_VIEW,
    fullCalendarView: "timeGridDay",
    picker: "day",
  },
  [WEEKLY_VIEW]: {
    label: WEEKLY_VIEW,
    fullCalendarView: "timeGridWeek",
    picker: "week",
  },
  [MONTHLY_VIEW]: {
    label: MONTHLY_VIEW,
    fullCalendarView: "dayGridMonth",
    picker: "month",
  },
};

export const LOCALE_CONFIG = {
  ja: {
    dayCellContent: arg => arg.date.getDate(),
    dayHeaderFormat: { weekday: "long" },
  },
};
